var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LoadingIcon",class:_vm.modifiers},[_c('div',{staticClass:"LoadingIcon__icon"}),(_vm.$slots.default)?_c('div',{staticClass:"LoadingIcon__text"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }